import { render, staticRenderFns } from "./prenext.vue?vue&type=template&id=7578b534&scoped=true&"
import script from "./prenext.vue?vue&type=script&lang=js&"
export * from "./prenext.vue?vue&type=script&lang=js&"
import style0 from "./prenext.vue?vue&type=style&index=0&id=7578b534&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7578b534",
  null
  
)

export default component.exports